module.exports = __webpack_public_path__ + "static/img/3-6.e4dd8571.png";